const GuardarTempos = (ydata) => async (dispatch) => {
  dispatch({ type: 'GET_RECURSOS_ASSOCIADOS', payload: ydata });
};

export default GuardarTempos;
